'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = ['M48 64l0 224 288 0 0-224c0-8.8-7.2-16-16-16l-80 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-48 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-32 0c-8.8 0-16 7.2-16 16z', 'M48 288L48 64c0-8.8 7.2-16 16-16l32 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 48 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 80 0c8.8 0 16 7.2 16 16l0 224-288 0zM0 320c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 320zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;